const GroupStafSearchCategories = ["id_group", "nama", "email_pimpinan"];

export default GroupStafSearchCategories;
